<template>
  <div class="about">
        <b-row>
      <b-col cols="2" class="menu-vertical">
        <p class="text-white">SERVICES FOR :</p>
        <ul>
          <li>
            <a href="/"><font color="#FFFFFF" face="Arial">Electronics Recycling</font></a>
          </li>
        </ul>
        <p>
          <img src="assets/images/index.3.gif" alt="certificado">
        </p>
      </b-col>
      <b-col cols="10" class="contenido">
      <buscador></buscador>
      <listado></listado>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import buscador from '@/components/buscador.vue'
import listado from '@/components/listado.vue'

export default {
  name: 'Home',
  components: {
    buscador,
    listado
  },
  data(){
    return{
      contador: 0
    }
  }
}
</script>

<style scoped>

.menu-vertical {
  background-color: #006600;
  width: 15.1%;
}
.contenido{
  background-color: #FFF;
  width: 80%;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .menu-vertical {
    display: none;
  }
}

</style>
